import React, { createContext, useReducer } from "react";
import { reducer } from "./reducer";
import { initialState } from "./state";

export const RikjangCtx = createContext();

function RikjangContext({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <RikjangCtx.Provider value={{ state, dispatch }}>
      {children}
    </RikjangCtx.Provider>
  );
}

export default RikjangContext;
